module.exports = __webpack_public_path__ + "img/close-red.1e729645.svg";